const { Expandable } = window.kaplanBlocks;

const setup = () => {
	const menu = document.querySelector( '.university-navigation__menu' );
	if ( ! menu ) {
		return;
	}

	menu.querySelectorAll( 'li.menu-item-has-children' ).forEach( ( item ) => {
		const link = item.querySelector( ':scope > a:not([class])' );
		if ( ! link ) {
			return;
		}

		const subMenu = item.querySelector( ':scope > .sub-menu' );
		if ( ! subMenu ) {
			return;
		}

		item.classList.add( 'kaplan-expandable' );

		const button = document.createElement( 'button' );

		const id = item.id + '-submenu';

		button.type = 'button';
		button.setAttribute( 'aria-expanded', false );

		subMenu.id = id;
		button.setAttribute( 'aria-controls', id );

		button.innerHTML = link.innerText;
		link.replaceWith( button );
	} );

	new Expandable( menu );
};

const showCollegesSubmenus = () => {
	const collegesButtonsLinks = document.querySelectorAll( '.university-navigation--multiple .university-navigation__menu > li.menu-item-has-children > a' );
	const collegesButtonsLi = document.querySelectorAll( '.university-navigation--multiple .university-navigation__menu > li.menu-item-has-children' );
	const closeCollegeSubMenusButtons = document.querySelectorAll( '.university-navigation__college-submenu__close' );

	collegesButtonsLinks.forEach( ( item ) => {
		item.addEventListener( 'click', ( e ) => {
			toggleCollegeSubmenu( item.parentElement.id );
			e.preventDefault();
			e.stopPropagation();
		} );
	} );

	collegesButtonsLi.forEach( ( item ) => {
		item.addEventListener( 'click', ( e ) => {
			toggleCollegeSubmenu( item.id );
			e.preventDefault();
		} );
	} );

	closeCollegeSubMenusButtons.forEach( ( item ) => {
		item.addEventListener( 'click', ( e ) => {
			hideCollegesSubMenus();
		} );
	} );
};

const toggleCollegeSubmenu = ( subMenuId ) => {
	// First hide all the submenus.
	hideCollegesSubMenus();

	const collegeSubMenu = document.querySelector( '[data-submenu="' + subMenuId + '"]' );
	collegeSubMenu.classList.add( 'active' );
};

const hideCollegesSubMenus = () => {
	const collegeSubMenu = document.querySelectorAll( '.university-navigation__college-submenu' );
	collegeSubMenu.forEach( ( item ) => {
		item.classList.remove( 'active' );
	} );
};

// Apply Navigation submenus only in mobiles.
const callShowCollegesSubmenus = ( windowWidth ) => {
	if ( windowWidth.matches ) {
		document.addEventListener( 'DOMContentLoaded', showCollegesSubmenus );
	}
};

// Apply Navigation expandable feature, only for desktop versions.
const callSetup = ( windowWidth ) => {
	if ( ! windowWidth.matches ) {
		document.addEventListener( 'DOMContentLoaded', setup );
	}
};

let windowWidth = window.matchMedia( '(max-width: 1024px)' );
callShowCollegesSubmenus( windowWidth );
callSetup( windowWidth );
windowWidth.addListener( callShowCollegesSubmenus );
windowWidth.addListener( callSetup );
